import axios from 'axios';
import { Fancybox } from '@fancyapps/ui';

import BigScreenSlider from './components/BigScreenSlider';
import CommonSlider from './components/CommonSlider';
import CardsSlider from './components/CardsSlider';
import ExcimerFacts from './components/Excimer_facts';
import TestsGames from './components/TestsGames';
import ReviewSlider from './components/ReviewSlider';
import FormScripts from './components/FormScripts';
import Licenses from './components/Licenses';
import Accordeon from './components/Accordeon';
import Promotions from './components/Promotions';
import ClinicsDoctor from './components/ClinicsDoctor';
import GalleryJS from './components/GalleryJS';
import Filters from './components/Filters';
import Sidebar from './components/Sidebar';
import Video from './components/Video';
import Prices from './components/Prices';
import PhotoGallerySlider from './components/PhotoGallerySlider';
import SliderNotTab from './components/SliderNotTab';
import SliderNotTabPromo from './components/SliderNotTabPromo';
import CorrectionResultSlider from './components/CorrectionResultSlider';
import Contact from './components/Contact';
import Split from './components/Split';
import OurEquipmentSlider from './components/OurEquipmentSlider';
import Equipment from './components/Equipment';
import GallerySlider from './components/GallerySlider';
import NewsPhotosSlider from './components/NewsPhotosSlider';
import TabsAsk from './components/TabsAsk';
import SearchBlock from './components/SearchBlock';
import FaqPage from './components/FaqPage';
import Reviews from './components/Reviews';
import Header from './components/Header';
import FourStage from './components/FourStage';
import Operations from './components/Operations';
import ClinicsService from './components/ClinicsService';
import ClinicsPhotogallery from './components/ClinicsPhotogallery';
import DaltonismTest from './components/DaltonismTest';
import AskForms from './components/AskForms';
import PartnerForms from './components/PartnerForms';
import ReviewComplainModal from './components/ReviewComplainModal';
import CallRequestModal from './components/CallRequestModal';
import TabsHashScripts from './components/TabsHashScripts';
import FixedAside from './components/FixedAside';
import SalesPageScript from './components/sales';
import SpecialEquipment from './components/SpecialEquipment';
import ActionYM from './components/ActionYM';

Fancybox.bind('[data-fancybox="appointment"]', {
  on: {
    // eslint-disable-next-line consistent-return
    click: (fancybox, event) => {
      if (!event.target.classList.contains('is-selected')) {
        return false;
      }
    },
    done: (fancybox) => {
      // если был клик по ссылке из виджета (файл FixedAside.js)
      // то добавим класс к форме чтобы корректно передавать данные о событии в GTM
      if (window.forFancyBox3715601438) {
        fancybox.$container.querySelector('#appointment-form-template').classList.add(window.forFancyBox3715601438);
        window.forFancyBox3715601438 = null;

        // отправляем событие в GTM
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'GoalEvent',
            eventCategoryUA: 'appointmentFromWidget',
            eventActionUA: 'openForm',
            eventGoalYM: 'appointmentFromWidget_openForm',
            eventGA4: 'appointmentFromWidget_openForm',
          });
        }
      } else {
        // отправляем событие в GTM
        // eslint-disable-next-line no-lonely-if
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'GoalEvent',
            eventCategoryUA: 'appointment',
            eventActionUA: 'openTopForm',
            eventGoalYM: 'appointment_openTopForm',
            eventGA4: 'appointment_openTopForm',
          });
        }
      }
    },
    destroy() {
      const appointmentFormElement = document.querySelector('#appointment #appointment-form-template');
      if (appointmentFormElement) {
        delete appointmentFormElement.dataset.actionId;
      }
    },
  },
});

Fancybox.bind('[data-fancybox="callback"]', {
  on: {
    done: () => {
      // отправляем событие в GTM
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'GoalEvent',
          eventCategoryUA: 'callback',
          eventActionUA: 'openForm',
          eventGoalYM: 'callback_openForm',
          eventGA4: 'callback_openForm',
        });
      }
    },
  },
});

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

document.addEventListener('DOMContentLoaded', () => {
  BigScreenSlider(); // Большой слайдер на главной
  CommonSlider();
  CardsSlider(); //
  // Слайдер "Факты об Эксимер".
  ExcimerFacts();
  // Слайдер Тесты, игры, упражнения
  TestsGames();
  // Слайдер отзывов с Орбитами.
  ReviewSlider();
  // Слайдер "Лицензий" на странице "Лицензии и сертификаты клиники".
  Licenses();
  Promotions();
  ClinicsDoctor();
  Accordeon();
  // Кнопка загрузить для Отзывов врачей и Видео на странице видео отзывов.
  GalleryJS();
  Filters();
  // Слайдер с выводом Круглых картинок (4 на пк).
  CorrectionResultSlider();
  Sidebar();
  // Слайдер видео-отзывов на странице Отзывы.
  Video();
  Prices();
  // Слайдер фотографий на странице "Клиника".
  PhotoGallerySlider();
  SliderNotTab();
  Contact();
  Split();
  // Слайдер картинок на странице со статьей
  SliderNotTabPromo();
  // Слайдер оборудования на синем фоне
  OurEquipmentSlider();
  Equipment();
  //
  TabsAsk();
  NewsPhotosSlider();
  toTop();
  // Слайдер карточек "Почитать по теме".
  // Пример расположения: страница статьи. В самом низу статьи после категорий статьи.
  GallerySlider();
  SearchBlock();
  FaqPage();
  // Слайдер текстового блока Отзывов по теме. Серый фон, белая карточка.
  Reviews();
  Header();
  FourStage();
  Operations();
  ClinicsService();
  ClinicsPhotogallery();
  // Обработка Отправки формы Запись на приём
  FormScripts();
  // Форма Жалобы\Отзыва
  ReviewComplainModal();
  // Форма Заказать звонок
  CallRequestModal();
  DaltonismTest();
  AskForms();
  PartnerForms();
  TabsHashScripts();
  FixedAside();
  SpecialEquipment();
  ActionYM();

  function gotoLinkAnyPlaceInCard(e) {
    const target = e.currentTarget;
    const link = target.querySelector('a[data-link]');
    link.click();
  }

  const linksInCards = document.querySelectorAll('*[data-place]');
  if (linksInCards.length) {
    Array.prototype.slice.call(linksInCards).forEach((el) => {
      el.addEventListener('click', gotoLinkAnyPlaceInCard);
    });
  }

  function toTop() {
    const toTopBtn = document.querySelector('.to-top');
    function checkedScroll() {
      const heightW = Number.isNaN(window.innerHeight) ? window.clientHeight : window.innerHeight;
      if (window.pageYOffset < heightW) {
        toTopBtn.classList.add('disabled');
      } else {
        toTopBtn.classList.remove('disabled');
      }
    }

    if (toTopBtn) {
      checkedScroll();
      window.addEventListener('scroll', () => {
        checkedScroll();
      });
      toTopBtn.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }

  // плавный скролл для якорей (для блока навигации резкий скролл)
  function scrollTo(element, navigate = false) {
    const box = element.getBoundingClientRect();
    let height = 0;
    // компенсация высоты шапки
    if (window.innerWidth >= 1440) {
      height = 195;
    } else if (window.innerWidth >= 1024 && window.innerWidth < 1440) {
      height = 165;
    } else {
      height = 84;
    }
    if (!navigate) {
      window.scrollTo({
        top: box.top + document.documentElement.scrollTop - height,
        left: 0,
        behavior: 'smooth',
      });
    } else {
      window.scrollTo({
        top: box.top + document.documentElement.scrollTop - height,
        left: 0,
        behavior: 'instant',
      });
    }
  }

  // определение элемента до которого надо проскролить
  const allLinks = document.querySelectorAll('.navigate-block a[href*="#"]');
  if (allLinks) {
    Array.prototype.slice.call(allLinks).forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        const id = el.getAttribute('href').substr(1);
        const element = document.getElementById(id);
        if (element) {
          window.location.hash = `#${id}`;
          scrollTo(element, true);
        }
      });
    });
  }

  const windowHash = window.location.hash;
  if (windowHash) {
    const elementHashScroll = document.getElementById(String(windowHash).substr(1));
    if (elementHashScroll) {
      setTimeout(() => {
        scrollTo(elementHashScroll);
      }, 1000);
    }
  }

  SalesPageScript();

  // отлавливаем событие клика по ссылкам с номерами телефона
  document.querySelectorAll('a[href^=tel]').forEach((link) => {
    link.addEventListener('click', () => {
      // отправляем событие в GTM
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'GoalEvent',
          eventCategoryUA: 'phoneLink',
          eventActionUA: 'click',
          eventLabelUA: link.getAttribute('href'),
          eventGoalYM: 'phoneLink_click',
          eventGA4: 'phoneLink_click',
        });
      }
    });
  });
});

function setCookie(name, value, days) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/`;
}

function getCookie(name) {
  const matches = document.cookie.match(new RegExp(
    // eslint-disable-next-line no-useless-escape
    `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`,
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

const buttonOkCity = document.querySelector('.city-notification__button-ok');
const buttonChangeCity = document.querySelector('.city-notification__button-change');
const cityNotification = document.querySelector('.city-notification');
const cityNotificationContent = document.querySelector('.city-notification__content');
const cityChangeContent = document.querySelector('.city-notification__change-city');
const cityNotificationCloseBtn = document.querySelector('.city-notification__close-btn');

if (cityNotificationCloseBtn) {
  cityNotificationCloseBtn.addEventListener('click', () => {
    cityNotification.classList.toggle('_hide')
  })
}

if (buttonOkCity) {
  buttonOkCity.addEventListener('click', () => {
    setCookie('hiddenCityPopup', 'true', 30);
    cityNotification.classList.add('_hide');
  });
}

if (buttonChangeCity) {
  buttonChangeCity.addEventListener('click', (event) => {
    event.stopPropagation();

    setCookie('hiddenCityPopup', 'true', 30);
    cityNotificationContent.classList.add('_hide');
    cityChangeContent.classList.remove('_hide');
  });
}

if (cityNotification) {
  if (getCookie('hiddenCityPopup') !== 'true') {
    cityNotification.classList.remove('_hide');
  }
}

if (cityChangeContent) {
  cityChangeContent.addEventListener('click', (e) => {
    if (e.target.classList.contains('city-notification__city-link')) {
      cityNotification.classList.add('_hide');
    }
  });
}

const buttonOk = document.querySelector('.button__ok');
const cookie = document.querySelector('.content__cookie');
const countMessage = document.querySelector('.popup-count-message');
const toTop = document.querySelector('.to-top');

buttonOk.addEventListener('click', () => {
  setCookie('hiddenCookiePopup', 'true', 30);

  cookie.classList.remove('show');
  countMessage.classList.remove('to-up');
  toTop.classList.remove('to-up');
});

if (!window.matchMedia("(min-width: 620px)").matches) {
  if(document.querySelector(".button__cookie .button__ok")) {
    document.querySelector(".button__cookie .button__ok").textContent = "Ок";
  }
}
        

// Проверяем, если человек уже нажжимал кнопку OK, то не показываем ему попап
if (getCookie('hiddenCookiePopup') === 'true') {
  cookie.classList.remove('show');
  countMessage.classList.remove('to-up');
  toTop.classList.remove('to-up');
} else {
  cookie.classList.add('show');
  countMessage.classList.add('to-up');
  toTop.classList.add('to-up');
}

// загружаем версию для слабовидящих только когда необходимо
document.addEventListener('DOMContentLoaded', () => {
  const asyncLoad = (src, callback) => {
    const script = document.createElement('script');
    script.src = src;
    script.defer = true;
    if (callback) { script.onload = callback; }
    document.head.insertAdjacentElement('beforeend', script);
  };

  asyncLoad('/assets/js/bvi-modified.js', () => {
    document.querySelectorAll('.bvi-open').forEach((element) => {
      const cb = (event) => {
        event.preventDefault();

        window.addEventListener('open-impaired', () => {
          document.cookie = 'openBvi=true';
          // отправляем событие в GTM
          if (window.dataLayer) {
            window.dataLayer.push({
              event: 'GoalEvent',
              eventCategoryUA: 'versionForImpaired',
              eventActionUA: 'on',
              eventGoalYM: 'versionForImpaired_on',
              eventGA4: 'versionForImpaired_on',
            });
          }
        }, false);

        // eslint-disable-next-line no-new
        new window.isvek.Bvi();

        element.click();

        window.addEventListener('close-impaired', () => {
          document.cookie = 'openBvi=false';
          // отправляем событие в GTM
          if (window.dataLayer) {
            window.dataLayer.push({
              event: 'GoalEvent',
              eventCategoryUA: 'versionForImpaired',
              eventActionUA: 'off',
              eventGoalYM: 'versionForImpaired_off',
              eventGA4: 'versionForImpaired_off',
            });
          }
        }, false);

        element.removeEventListener('click', cb);
      };

      element.addEventListener('click', cb);
    });

    if (getCookie('openBvi') === 'true') {
      new window.isvek.Bvi();
    }
  });
});
